import { useLocation } from "react-router-dom";

// Returns "/app/recipes" or "/app/groceries" based on location
export function useLocationBase() {
  const location = useLocation();
  const locationBase = "/" + location.pathname.split("/")[1] + "/" + (location.pathname.split("/")[2] || "recipes");

  return locationBase;
}
